import React, { useContext } from "react";

import "./sunday-prayer.styles.css";
import { HidePrayersContext } from "../../contexts/hide-prayers-context";

const SundayPrayer = ({ prayer }) => {
  const { hidePrayers } = useContext(HidePrayersContext);

  return (
    <div style={{ display: "flex" }}>
      <div className={`sunday-prayer-card ${hidePrayers ? "inactive" : "active"}`}>
        <div>
          <div className="sunday-prayer-card-header">
            <div>
              {prayer.displayName ? (
                <h3 className="sunday-prayer-heading">{prayer.displayName}</h3>
              ) : (
                <h3 className="sunday-prayer-heading">Anonymous</h3>
              )}
            </div>
          </div>

          <div className="sunday-prayer-message">{prayer.message}</div>
        </div>
      </div>
    </div>
  );
};

export default SundayPrayer;
